webpackJsonp([269238729700051],{

/***/ "./assets/Downtown-Cville1.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Downtown-Cville1.a9299aee.jpg";

/***/ }),

/***/ "./assets/check.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAWCAYAAADTlvzyAAAABGdBTUEAALGPC/xhBQAAAchJREFUSA21lrtOAkEUhs9RI7wANAQbpJGHQAoDagNYi9HCV/BtTGwsERMvS2Ky4DtQ4aUQLHwCMWTH8+/KXlgWFnY9DXPm8n/zn5nZQPRf0ettUke7pW77xI1gdxJbG7CvjyaROiQmg3jtjIrlK+ivxQaZCPX7CRuGPiUMZVxSV2sgjdchYMOXpkAOIO4J0ymfrns6oyTzYJaumONkPA5N2OsNKbUfvGduEyWq0c8wDIxZA4xKpe9oDsPCVKIGGNx7gc9PO2SMLyiTO6d8fhRcHhmxYC0pYyVwHpxlclW3llNSC6aLQIOGch4QDIoVYZCzHDqwtM1gfpTd1dy7M8d0PUk0askDK9tzpxtBa2Ue0yzYRGB6YUQYZDfMM1PKcTaB4RfX3CpvjQYDqcYiZ/QgVan7quLS5L/DX/CGqE3M8olSe6613iYDtj0XhgXWGYa53l55bxYShkXWLcUTwAXBmS0dfE+pLf/lCtDxvsOlnQosna1TofAToO/r9gIxHBbKfEep7NEyMMj7gQ5Uk0uyi9QXzB2BlZeFQWc2ECNw+vnWJsMoIrWDWRdYZRUYNIKBGJ2GRoQtBtrQ92v5mzAWZ8erOoMU4hds5uUbfoSzdQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "./assets/couple.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/couple.22403071.png";

/***/ }),

/***/ "./assets/jobs-grid.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/jobs-grid.da5ad27d.png";

/***/ }),

/***/ "./assets/kevin.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kevin.0b7ce4fe.jpg";

/***/ }),

/***/ "./assets/placeholder.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuNCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9InVpa2l0X3BsYWNlaG9sZGVyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiCgkgeT0iMHB4IiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgNTAwIDUwMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNTAwIDUwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxyZWN0IHg9Ii0wLjUiIHk9IjEiIGZpbGw9IiNGOEY4RjgiIHdpZHRoPSI1MDAuMjUiIGhlaWdodD0iNTAwIi8+CjxnPgoJPHBhdGggZmlsbD0iIzc3Nzc3NyIgZD0iTTE4Mi4zMTUsMTk2Ljc1djEwNi41aDEzNS4zN3YtMTA2LjVIMTgyLjMxNUwxODIuMzE1LDE5Ni43NXogTTMwNi43OCwyOTEuNzAzSDE5My44NjR2LTgzLjQwNEgzMDYuNzgKCQlWMjkxLjcwM0wzMDYuNzgsMjkxLjcwM3oiLz4KCTxwb2x5Z29uIGZpbGw9IiM3Nzc3NzciIHBvaW50cz0iMTk5LjcxNSwyODIuODY1IDIyMy4wODgsMjU4LjI5NSAyMzEuODQ3LDI2Mi4wODggMjU5LjQ3NywyMzIuNjYxIDI3MC4zNTgsMjQ1LjY3NiAKCQkyNzUuMjYyLDI0Mi43MTEgMzAxLjgyNywyODIuODY1IAkiLz4KCTxjaXJjbGUgZmlsbD0iIzc3Nzc3NyIgY3g9IjIyNi43MTkiIGN5PSIyMjkuNDE3IiByPSIxMC4yMSIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "./assets/vial-horizontal.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vial-horizontal.a9480f96.png";

/***/ }),

/***/ "./assets/virginia.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/virginia.7914a24d.png";

/***/ }),

/***/ "./node_modules/react-scrollchor/lib/scrollchor.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__("./node_modules/react-scrollchor/lib/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scrollchor = function (_React$Component) {
	  _inherits(Scrollchor, _React$Component);
	
	  function Scrollchor(props) {
	    _classCallCheck(this, Scrollchor);
	
	    var _this = _possibleConstructorReturn(this, (Scrollchor.__proto__ || Object.getPrototypeOf(Scrollchor)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this._setup(props);
	    _this.simulateClick = _this._handleClick;
	    return _this;
	  }
	
	  _createClass(Scrollchor, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      this._setup(props);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          to = _props.to,
	          animate = _props.animate,
	          beforeAnimate = _props.beforeAnimate,
	          afterAnimate = _props.afterAnimate,
	          props = _objectWithoutProperties(_props, ["to", "animate", "beforeAnimate", "afterAnimate"]); // eslint-disable-line no-unused-vars
	
	      return !this.props.children ? null : _react2.default.createElement("a", _extends({}, props, { href: "#" + this._to, onClick: this._handleClick }));
	    }
	  }]);
	
	  return Scrollchor;
	}(_react2.default.Component);
	
	// Default easing function
	// jQuery easing 'swing'
	
	
	Scrollchor.propTypes = {
	  to: _propTypes2.default.string.isRequired,
	  animate: _propTypes2.default.shape({
	    offset: _propTypes2.default.number,
	    duration: _propTypes2.default.number,
	    easing: _propTypes2.default.func
	  }),
	  beforeAnimate: _propTypes2.default.func,
	  afterAnimate: _propTypes2.default.func
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setup = function (props) {
	    _this2._to = props.to && props.to.replace(/^#/, "") || "";
	
	    var _ref = props.animate || {},
	        _ref$offset = _ref.offset,
	        offset = _ref$offset === undefined ? 0 : _ref$offset,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 400 : _ref$duration,
	        _ref$easing = _ref.easing,
	        easing = _ref$easing === undefined ? easeOutQuad : _ref$easing;
	
	    _this2._animate = { offset: offset, duration: duration, easing: easing };
	    _this2._beforeAnimate = props.beforeAnimate || function () {};
	    _this2._afterAnimate = props.afterAnimate || function () {};
	  };
	
	  this._handleClick = function (event) {
	    _this2._beforeAnimate(event);
	    event && event.preventDefault();
	    (0, _utils.animateScroll)(_this2._to, _this2._animate);
	    _this2._afterAnimate(event);
	  };
	};
	
	exports.default = Scrollchor;
	function easeOutQuad(x, t, b, c, d) {
	  return -c * (t /= d) * (t - 2) + b;
	}

/***/ }),

/***/ "./node_modules/react-scrollchor/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animateScroll = animateScroll;
	
	var _warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function animateScroll(id, animate) {
	  var element = id ? document.getElementById(id) : document.body;
	  (0, _warning2.default)(element, "Cannot find element: #" + id);
	
	  var offset = animate.offset,
	      duration = animate.duration,
	      easing = animate.easing;
	
	  var start = getScrollTop();
	  var to = getOffsetTop(element) + offset;
	  var change = to - start;
	
	  function animateFn() {
	    var elapsedTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    var increment = 20;
	    var elapsed = elapsedTime + increment;
	    var position = easing(null, elapsed, start, change, duration);
	    setScrollTop(position);
	    elapsed < duration && setTimeout(function () {
	      return animateFn(elapsed);
	    }, increment);
	  }
	
	  animateFn();
	  window.location.hash = id;
	}
	
	function getScrollTop() {
	  // like jQuery -> $('html, body').scrollTop
	  return document.documentElement.scrollTop || document.body.scrollTop;
	}
	
	function setScrollTop(position) {
	  document.documentElement.scrollTop = document.body.scrollTop = position;
	}
	
	function getOffsetTop(element) {
	  var _element$getBoundingC = element.getBoundingClientRect(),
	      top = _element$getBoundingC.top;
	
	  return top + getScrollTop();
	}

/***/ }),

/***/ "./src/components/BenefitGrid.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 1.5rem 1rem;\n  ", ";\n"], ["\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 1.5rem 1rem;\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  height: 1rem;\n  padding-top: .3rem;\n  padding-bottom: .1rem;\n  padding-right: .2rem;\n"], ["\n  height: 1rem;\n  padding-top: .3rem;\n  padding-bottom: .1rem;\n  padding-right: .2rem;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  padding-bottom: 0;\n  padding-left: .5rem;\n  font-size: 1.0625rem;\n"], ["\n  flex: 1;\n  padding-bottom: 0;\n  padding-left: .5rem;\n  font-size: 1.0625rem;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _utils = __webpack_require__("./src/utils.js");
	
	var _check = __webpack_require__("./assets/check.png");
	
	var _check2 = _interopRequireDefault(_check);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Grid = _styledComponents2.default.div(_templateObject, (0, _utils.r)("padding", "4rem 2rem", "4rem .5rem"));
	
	var Check = _styledComponents2.default.img(_templateObject2);
	
	var Text = _typography.Description.extend(_templateObject3);
	
	var Benefit = _styledComponents2.default.div(_templateObject4);
	
	exports.default = function (_ref) {
	  var _ref$list = _ref.list,
	      list = _ref$list === undefined ? [] : _ref$list;
	  return _react2.default.createElement(
	    Grid,
	    null,
	    list.map(function (benefit) {
	      return _react2.default.createElement(
	        Benefit,
	        { benefit: benefit },
	        _react2.default.createElement(Check, { src: _check2.default }),
	        _react2.default.createElement(
	          Text,
	          null,
	          benefit
	        )
	      );
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/CvilleList.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  max-width: 25rem;\n  width: 100%;\n  display: flex;\n  ", ";\n  padding-left: 2.5rem;\n  margin: 0;\n"], ["\n  max-width: 25rem;\n  width: 100%;\n  display: flex;\n  ", ";\n  padding-left: 2.5rem;\n  margin: 0;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  font-size: 1.3rem;\n  line-height: 1.3;\n  padding-bottom: .5rem;\n  list-style: none;\n  position: relative;\n  &:before {\n    content: \"\x002192\";\n    position: absolute;\n    left: -1.7rem;\n    color: ", ";\n  }\n"], ["\n  font-size: 1.3rem;\n  line-height: 1.3;\n  padding-bottom: .5rem;\n  list-style: none;\n  position: relative;\n  &:before {\n    content: \"\\0002192\";\n    position: absolute;\n    left: -1.7rem;\n    color: ", ";\n  }\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _utils = __webpack_require__("./src/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var List = _styledComponents2.default.ul(_templateObject, (0, _utils.r)("flex-direction", "column", "column"));
	
	var Item = _styledComponents2.default.li(_templateObject2, (0, _utils.getThemeColor)("teal"));
	
	exports.default = function (_ref) {
	  var _ref$benefits = _ref.benefits,
	      benefits = _ref$benefits === undefined ? [] : _ref$benefits;
	  return _react2.default.createElement(
	    List,
	    null,
	    benefits.map(function (benefit) {
	      return _react2.default.createElement(
	        Item,
	        null,
	        _react2.default.createElement(
	          _typography.H4,
	          null,
	          benefit.title
	        ),
	        _react2.default.createElement(
	          _typography.Description,
	          null,
	          benefit.description
	        )
	      );
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/Image.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: grid;\n  justify-content: ", ";\n  width: ", ";\n  flex: ", ";\n  margin: 0 auto;\n"], ["\n  display: grid;\n  justify-content: ", ";\n  width: ", ";\n  flex: ", ";\n  margin: 0 auto;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  height: auto;\n  width: 100%;\n"], ["\n  height: auto;\n  width: 100%;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-end;\n  padding: 1rem 1.5rem;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  padding: 1rem 1.5rem;\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _vialHorizontal = __webpack_require__("./assets/vial-horizontal.png");
	
	var _vialHorizontal2 = _interopRequireDefault(_vialHorizontal);
	
	var _placeholder = __webpack_require__("./assets/placeholder.svg");
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	var _DowntownCville = __webpack_require__("./assets/Downtown-Cville1.jpg");
	
	var _DowntownCville2 = _interopRequireDefault(_DowntownCville);
	
	var _kevin = __webpack_require__("./assets/kevin.jpg");
	
	var _kevin2 = _interopRequireDefault(_kevin);
	
	var _jobsGrid = __webpack_require__("./assets/jobs-grid.png");
	
	var _jobsGrid2 = _interopRequireDefault(_jobsGrid);
	
	var _couple = __webpack_require__("./assets/couple.png");
	
	var _couple2 = _interopRequireDefault(_couple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ImageSourceMap = {
	  vial: _vialHorizontal2.default,
	  downtownCharlottesville: _DowntownCville2.default,
	  kevin: _kevin2.default,
	  CareerGrid: _jobsGrid2.default,
	  placeholder: _placeholder2.default,
	  couple: _couple2.default
	};
	
	var ImageContainer = _styledComponents2.default.div(_templateObject, function (_ref) {
	  var align = _ref.align;
	  return align || "center";
	}, function (_ref2) {
	  var full = _ref2.full;
	  return full ? "100%" : "80%";
	}, function (_ref3) {
	  var full = _ref3.full;
	  return full ? 1 : "none";
	});
	
	var Image = _styledComponents2.default.img(_templateObject2);
	
	var Caption = _styledComponents2.default.div(_templateObject3);
	
	exports.default = function (_ref4) {
	  var _ref4$image = _ref4.image,
	      image = _ref4$image === undefined ? "" : _ref4$image,
	      caption = _ref4.caption,
	      _ref4$full = _ref4.full,
	      full = _ref4$full === undefined ? false : _ref4$full,
	      _ref4$align = _ref4.align,
	      align = _ref4$align === undefined ? "center" : _ref4$align;
	  return _react2.default.createElement(
	    ImageContainer,
	    { full: full, align: align, className: "image" },
	    _react2.default.createElement(Image, { src: image }),
	    caption && _react2.default.createElement(
	      Caption,
	      null,
	      caption
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/PositionList.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding: 4rem 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 4rem 0;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  ", ";\n  max-width: 42rem;\n"], ["\n  ", ";\n  max-width: 42rem;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  font-size: 1.2rem;\n  line-height: 1.6;\n"], ["\n  font-size: 1.2rem;\n  line-height: 1.6;\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _utils = __webpack_require__("./src/utils.js");
	
	var _check = __webpack_require__("./assets/check.png");
	
	var _check2 = _interopRequireDefault(_check);
	
	var _ArrowLink = __webpack_require__("./src/components/ArrowLink.js");
	
	var _ArrowLink2 = _interopRequireDefault(_ArrowLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var List = _styledComponents2.default.div(_templateObject);
	
	var Position = _styledComponents2.default.div(_templateObject2, (0, _utils.r)("padding", "2.5rem 2rem", "2.5rem .5rem 1.5rem"));
	
	var CareerText = _typography.P.extend(_templateObject3);
	
	exports.default = function (_ref) {
	  var _ref$list = _ref.list,
	      list = _ref$list === undefined ? [] : _ref$list;
	  return _react2.default.createElement(
	    List,
	    null,
	    list.map(function (position) {
	      return _react2.default.createElement(
	        Position,
	        { position: position },
	        _react2.default.createElement(
	          _typography.H4,
	          { serif: true },
	          position.title
	        ),
	        _react2.default.createElement(
	          CareerText,
	          null,
	          position.description.description
	        ),
	        position.title !== "No Open Positions" && _react2.default.createElement(
	          CareerText,
	          { style: { paddingTop: ".3rem" } },
	          _react2.default.createElement(
	            _ArrowLink2.default,
	            {
	              to: "/careers/" + position.id + "#" + (0, _utils.slugify)(position.title)
	            },
	            "Apply for position"
	          )
	        )
	      );
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/Virginia.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.VirginiaHero = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  width: 100%;\n  padding-top: 2rem;\n  padding-bottom: 0;\n  .intro {\n    max-width: 42rem;\n  }\n  @media (max-width: 1100px) {\n    padding-bottom: 18rem;\n  }\n  @media (max-width: 720px) {\n    padding-bottom: 10rem;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  width: 100%;\n  padding-top: 2rem;\n  padding-bottom: 0;\n  .intro {\n    max-width: 42rem;\n  }\n  @media (max-width: 1100px) {\n    padding-bottom: 18rem;\n  }\n  @media (max-width: 720px) {\n    padding-bottom: 10rem;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  width: 40rem;\n  position: absolute;\n  right: 0;\n  padding-top: 2rem;\n  @media (max-width: 1100px) {\n    bottom: 0;\n    opacity: .8;\n    right: 0;\n  }\n  @media (max-width: 720px) {\n    width: 100%;\n  }\n"], ["\n  width: 40rem;\n  position: absolute;\n  right: 0;\n  padding-top: 2rem;\n  @media (max-width: 1100px) {\n    bottom: 0;\n    opacity: .8;\n    right: 0;\n  }\n  @media (max-width: 720px) {\n    width: 100%;\n  }\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _virginia = __webpack_require__("./assets/virginia.png");
	
	var _virginia2 = _interopRequireDefault(_virginia);
	
	var _Pulse = __webpack_require__("./src/components/atoms/Pulse.js");
	
	var _Pulse2 = _interopRequireDefault(_Pulse);
	
	var _Responsive = __webpack_require__("./src/components/blocks/Responsive.js");
	
	var _utils = __webpack_require__("./src/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var VirginiaHero = exports.VirginiaHero = _styledComponents2.default.div(_templateObject);
	var VirginiaWrapper = _styledComponents2.default.div(_templateObject2);
	
	exports.default = function () {
	  return _react2.default.createElement(
	    VirginiaWrapper,
	    null,
	    _react2.default.createElement("img", {
	      src: _virginia2.default,
	      alt: "Charlottesville is a beautiful place to live and work.",
	      style: { width: "100%" }
	    }),
	    _react2.default.createElement(
	      _Responsive.ShowMobile,
	      null,
	      _react2.default.createElement(_Pulse2.default, { top: "53.66%", right: "39.3%" })
	    ),
	    _react2.default.createElement(
	      _Responsive.HideMobile,
	      null,
	      _react2.default.createElement(_Pulse2.default, { top: "10.407rem", right: "15.955rem" })
	    )
	  );
	};

/***/ }),

/***/ "./src/components/atoms/Pulse.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: ", ";\n  top: ", ";\n  display: block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: ", ";\n  box-shadow: 0 0 0 ", ";\n  animation: pulse 2s infinite;\n\n  @-webkit-keyframes pulse {\n    0% {\n      -webkit-box-shadow: 0 0 0 0 ", ";\n    }\n    70% {\n      -webkit-box-shadow: 0 0 0 20px rgba(204, 169, 44, 0);\n    }\n    100% {\n      -webkit-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);\n    }\n  }\n  @keyframes pulse {\n    0% {\n      -moz-box-shadow: 0 0 0 0 ", ";\n      box-shadow: 0 0 0 0 ", ";\n    }\n    70% {\n      -moz-box-shadow: 0 0 0 20px rgba(204, 169, 44, 0);\n      box-shadow: 0 0 0 15px rgba(204, 169, 44, 0);\n    }\n    100% {\n      -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);\n      box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);\n    }\n  }\n"], ["\n  position: absolute;\n  right: ", ";\n  top: ", ";\n  display: block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: ", ";\n  box-shadow: 0 0 0 ", ";\n  animation: pulse 2s infinite;\n\n  @-webkit-keyframes pulse {\n    0% {\n      -webkit-box-shadow: 0 0 0 0 ", ";\n    }\n    70% {\n      -webkit-box-shadow: 0 0 0 20px rgba(204, 169, 44, 0);\n    }\n    100% {\n      -webkit-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);\n    }\n  }\n  @keyframes pulse {\n    0% {\n      -moz-box-shadow: 0 0 0 0 ", ";\n      box-shadow: 0 0 0 0 ", ";\n    }\n    70% {\n      -moz-box-shadow: 0 0 0 20px rgba(204, 169, 44, 0);\n      box-shadow: 0 0 0 15px rgba(204, 169, 44, 0);\n    }\n    100% {\n      -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);\n      box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);\n    }\n  }\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Pulse = _styledComponents2.default.div(_templateObject, function (_ref) {
	  var right = _ref.right;
	  return right;
	}, function (_ref2) {
	  var top = _ref2.top;
	  return top;
	}, function (props) {
	  return props.theme.colors.teal;
	}, function (props) {
	  return props.theme.colors.teal;
	}, function (props) {
	  return props.theme.colors.teal;
	}, function (props) {
	  return props.theme.colors.teal;
	}, function (props) {
	  return props.theme.colors.teal;
	});
	
	exports.default = function (_ref3) {
	  var _ref3$top = _ref3.top,
	      top = _ref3$top === undefined ? "" : _ref3$top,
	      _ref3$right = _ref3.right,
	      right = _ref3$right === undefined ? "" : _ref3$right;
	  return _react2.default.createElement(Pulse, { top: top, right: right });
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/opt/build/repo/node_modules/babel-preset-react-app/index.js\",[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\",[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/react-hot-loader/babel.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/careers/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  font-size: 1.2rem;\n  line-height: 1.6;\n"], ["\n  font-size: 1.2rem;\n  line-height: 1.6;\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactScrollchor = __webpack_require__("./node_modules/react-scrollchor/lib/scrollchor.js");
	
	var _reactScrollchor2 = _interopRequireDefault(_reactScrollchor);
	
	var _NavBar = __webpack_require__("./src/components/NavBar.js");
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _selectors = __webpack_require__("./src/selectors.js");
	
	var _Emphasis = __webpack_require__("./src/components/atoms/Emphasis.js");
	
	var _Emphasis2 = _interopRequireDefault(_Emphasis);
	
	var _Section = __webpack_require__("./src/components/blocks/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Responsive = __webpack_require__("./src/components/blocks/Responsive.js");
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	var _Flex = __webpack_require__("./src/components/blocks/Flex.js");
	
	var _Pad = __webpack_require__("./src/components/blocks/Pad.js");
	
	var _Pad2 = _interopRequireDefault(_Pad);
	
	var _Image = __webpack_require__("./src/components/Image.js");
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Background = __webpack_require__("./src/components/blocks/Background.js");
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _ArrowLink = __webpack_require__("./src/components/ArrowLink.js");
	
	var _Virginia = __webpack_require__("./src/components/Virginia.js");
	
	var _Virginia2 = _interopRequireDefault(_Virginia);
	
	var _BenefitGrid = __webpack_require__("./src/components/BenefitGrid.js");
	
	var _BenefitGrid2 = _interopRequireDefault(_BenefitGrid);
	
	var _CvilleList = __webpack_require__("./src/components/CvilleList.js");
	
	var _CvilleList2 = _interopRequireDefault(_CvilleList);
	
	var _PositionList = __webpack_require__("./src/components/PositionList.js");
	
	var _PositionList2 = _interopRequireDefault(_PositionList);
	
	var _logofavcon2x = __webpack_require__("./assets/logofavcon@2x.png");
	
	var _logofavcon2x2 = _interopRequireDefault(_logofavcon2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CareerText = _typography.P.extend(_templateObject);
	
	var CareerPage = function (_React$Component) {
	  _inherits(CareerPage, _React$Component);
	
	  function CareerPage() {
	    _classCallCheck(this, CareerPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CareerPage.prototype.render = function render() {
	    var content = (0, _selectors.getGraphNode)(this.props.data, "CareerPage");
	    var jobs = content.positions;
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        {
	          title: "Contraline Careers",
	          meta: [{ name: "Contraline", content: "Careers" }]
	        },
	        _react2.default.createElement("link", { rel: "icon", type: "image/png", href: _logofavcon2x2.default })
	      ),
	      _react2.default.createElement(_NavBar2.default, { color: "dark", background: "greyLight" }),
	      _react2.default.createElement(
	        _Background2.default,
	        { color: "greyLight" },
	        _react2.default.createElement(
	          _Section2.default,
	          { padLarge: true, noBorder: true, fixed: true },
	          _react2.default.createElement(
	            _Virginia.VirginiaHero,
	            null,
	            _react2.default.createElement(_Virginia2.default, null),
	            _react2.default.createElement(
	              "div",
	              { className: "intro" },
	              _react2.default.createElement(
	                _typography.H1,
	                { serif: true, weight: "bold" },
	                content.headerTitle
	              ),
	              _react2.default.createElement(
	                CareerText,
	                null,
	                content.virginiaHeroText.virginiaHeroText
	              ),
	              _react2.default.createElement(
	                CareerText,
	                { color: "teal", style: { paddingTop: ".5rem" } },
	                _react2.default.createElement(
	                  _reactScrollchor2.default,
	                  {
	                    to: "#open-positions",
	                    className: "nav-link",
	                    style: {
	                      position: "relative",
	                      cursor: "pointer",
	                      color: "inherit",
	                      textDecoration: "none"
	                    },
	                    animate: { duration: 600 }
	                  },
	                  _react2.default.createElement(
	                    _ArrowLink.ArrowBody,
	                    null,
	                    content.openPositionLink
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Spacer2.default, { span: 3 }),
	        _react2.default.createElement(
	          _Section2.default,
	          null,
	          _react2.default.createElement(_Image2.default, {
	            alt: "Research at Contraline",
	            image: content.careerGrid.responsiveResolution.src,
	            full: true,
	            style: { width: "100%", paddingTop: "2rem" }
	          })
	        ),
	        _react2.default.createElement(
	          _Section2.default,
	          null,
	          _react2.default.createElement(
	            _Emphasis2.default,
	            null,
	            _react2.default.createElement(
	              _typography.H4,
	              null,
	              content.benefitsTitle
	            )
	          ),
	          _react2.default.createElement(_BenefitGrid2.default, { list: content.benefitsList.benefitsList.split("|") })
	        )
	      ),
	      _react2.default.createElement("div", { id: "open-positions" }),
	      _react2.default.createElement(
	        _Section2.default,
	        null,
	        _react2.default.createElement(
	          _Emphasis2.default,
	          null,
	          _react2.default.createElement(
	            _typography.H4,
	            null,
	            content.openPositionsTitle
	          )
	        ),
	        _react2.default.createElement(_PositionList2.default, { list: jobs })
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        null,
	        _react2.default.createElement(
	          _Emphasis2.default,
	          null,
	          _react2.default.createElement(
	            _typography.H4,
	            null,
	            content.locationTitle
	          )
	        ),
	        _react2.default.createElement(_Spacer2.default, { span: 3 }),
	        _react2.default.createElement(
	          _Flex.HFlexFlipper,
	          { align: "flex-start" },
	          _react2.default.createElement(
	            _Pad2.default,
	            { h: 1, mh: 0.5 },
	            _react2.default.createElement(_Image2.default, {
	              full: true,
	              align: "center",
	              caption: content.cvilleImageCaption,
	              image: content.cvilleImage.responsiveResolution.src
	            })
	          ),
	          _react2.default.createElement(
	            _Responsive.ShowMobile,
	            null,
	            _react2.default.createElement(_Spacer2.default, { span: 2.5 })
	          ),
	          _react2.default.createElement(_CvilleList2.default, { benefits: content.cvilleImageList.entries })
	        )
	      )
	    );
	  };
	
	  return CareerPage;
	}(_react2.default.Component);
	
	exports.default = CareerPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-careers-index-js-2709b92545a369124784.js